// extracted by mini-css-extract-plugin
export var button = "_af-2";
export var card = "_af-0";
export var closeButtonContainer = "_af-3";
export var iconContainer = "_af-1";